import styles from "./Spinner.module.scss";

export const Spinner = ({ ...props }) => (
  <div className={styles.spinner} {...props}></div>
);
